module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/recommend_4_02-03fa207624844ff22b92f5f6aa0519e9.jpg";